import { render, staticRenderFns } from "./SEOEntity.vue?vue&type=template&id=8f248020&"
import script from "./SEOEntity.vue?vue&type=script&lang=js&"
export * from "./SEOEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports